/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import type { FeatureBlockProps } from '~/editor/blocks/feature/FeatureBlockProps';
import { css_background, css_gap, css_xlarge, css_small_down, css_stroke, css_text } from '~/emotion/theme';

export default function FeatureBlockAlpha({ features }: FeatureBlockProps) {
	return (
		<Wrapper>
			<Divider />
			<FeatureList>
				{features.map((feature, index) => (
					<FeatureChip key={index}>{feature}</FeatureChip>
				))}
			</FeatureList>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	width: 100%;
`;

const Divider = styled.div`
	border-top: 1px solid ${css_stroke()};
	margin-bottom: ${css_gap('content')};
`;

const FeatureList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.6rem;

	@media (${css_xlarge}) {
		justify-content: space-between;
	}

	@media (${css_small_down}) {
		justify-content: center;
	}
`;

const FeatureChip = styled.div`
	background: ${css_background()};
	padding: 0.5rem 0.6rem;
	color: ${css_text('weak')};
	font-size: 0.9rem;
	border: 1px solid ${css_stroke()};
`;
